import { View } from "./View";

export const Settings = () => {
  return <View />;
};
